module.exports = __webpack_public_path__ + "img/icon-chevron.9fd7cbab.svg";